import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, required, ...props }, ref) => {
  return (
    <textarea
      aria-required={required || undefined}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-[hsl(var(--input-border))] bg-[hsl(var(--input-bg))] text-[hsl(var(--input-fg))] px-3 py-2 text-base shadow-sm placeholder:text-[hsl(var(--input-ph))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        required && "ui-required",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
